<template>
  <div class="d-flex align-center" role="group" aria-label="Servings">
    <v-btn
      icon="mdi-minus"
      variant="text"
      size="small"
      aria-label="Fewer servings"
      :disabled="modelValue <= min"
      @click="$emit('update:modelValue', modelValue - 1)"
    />
    <span class="text-body-large mx-1" aria-live="polite">
      {{ modelValue }} {{ modelValue === 1 ? 'serving' : 'servings' }}
    </span>
    <v-btn
      icon="mdi-plus"
      variant="text"
      size="small"
      aria-label="More servings"
      :disabled="modelValue >= max"
      @click="$emit('update:modelValue', modelValue + 1)"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'ServingsSelector',
    props: {
      modelValue: {
        type: Number,
        required: true,
      },
      min: {
        type: Number,
        default: 1,
      },
      max: {
        type: Number,
        default: 99,
      },
    },
    emits: {
      'update:modelValue': (_servings: number) => true,
    },
  });
</script>
